/*global ga _gaq dataLayer _satellite */

import { getCurrentBagData } from '../bag/bag-services';
import { getCookie } from '../cookies/cookies';

// Define dataLayer and the gtag function.
window.dataLayer = window.dataLayer || [];
function gtag(event: string, eventName: string, eventData: Object) { dataLayer.push(arguments); }

export const gaTracking = async (eventName: string, bagDataNeeded: boolean = false, data: Object = {}, ) => {
    let trackingData = data;
    if (bagDataNeeded) {
        const basketData = await getCurrentBagData();
        // Extract product code and title properties and creating a new array
        const basketItems = basketData.basket.items.map(item => {
            return {
                item_id: item.product.productCode,
                item_name: item.product.title,
                quantity: item.quantity,
                item_brand: item.brand,
                item_category: item.category,
                price: item.itemPrice,
                search_term: item.searchTerm
            };            
        });   
        const basketIncludes = {
            currency: basketData.basket.currency,
            value: basketData.basket.total
        };
        let items = { items: basketItems }
        trackingData = { ...data, ...basketIncludes, ...items };
    } 
    trackingData = {
        ...trackingData,
        email_address: getCookie('hashed_email') || ""
    };
    gtag("event", eventName, trackingData);
};

export const dispatchEventWrapper = (el, name, data) => {
    const evt = new CustomEvent(name, {
        detail: data,
        bubbles: true
    });
    el.dispatchEvent(evt);
};

export const listenEvents = () => {

    (document.querySelectorAll(`[href^="tel:"]`)as NodeListOf<HTMLAnchorElement>)
        .forEach(elm => {
            elm.addEventListener('click', () => {
                var phoneNumber = /^tel:(.*)/.exec(elm.href);
                if (phoneNumber.length > 1) {
                    window.dataLayer.push({
                        'page_action': 'telephone_click',
                        'page_telephone_number': phoneNumber
                    });
                }
            });
        });

    document.addEventListener('rc-filter-opened', (eventData: any) => track(eventData.detail));
    document.addEventListener('rc-filter-clicked', (eventData: any) => track(eventData.detail));
    document.addEventListener('rc-category-clicked', (eventData:any) => track(eventData.detail));
    document.addEventListener('rc-pageview', (eventData:any) => track(eventData.detail));
    document.addEventListener('rc-track-link', (eventData:any) => track(eventData.detail));
    document.addEventListener('rc-signup-clicked', (eventData:any) => track(eventData.detail));
    document.addEventListener('rc-menu-link-clicked', (eventData:any) => track(eventData.detail));
    document.addEventListener('rc-footer-link-clicked', (eventData:any) => track(eventData.detail));
    document.addEventListener('rc-add-to-bag-clicked', (eventData:any) => track(eventData.detail, { dataLayerPush: true }));
    document.addEventListener('rc-form-submit', (eventData:any) => track(eventData.detail));
};

const track = (eventdata:any, options = null) => {
    gaTrack(eventdata);
    if (options) {
        if (options.dataLayerPush) {
            window.dataLayer.push({
                event: 'Add to Bag',
                last_add_to_bag: eventdata
            });
        }
    }
};

const gaTrack = (eventData:any) => {
    const defaultData = {
        area: '',
        event: '',
        value: '',
        value2: undefined
    };
    const data = Object.assign(defaultData, eventData);

    if (document.location.hostname === "localhost" || document.location.hostname.indexOf('remarkable') > 0) {
        console.groupCollapsed('Tracking event fired');
        console.log(data);
        console.log(event);
        console.groupEnd();
    }

    try {
        if (typeof window.ga !== "undefined") {
            window.ga('send', 'event', data.area, data.event, data.value, data.value2);
        }
        else if (typeof window._gaq !== 'undefined') {
            window._gaq.push([
                '_trackEvent',
                data.area,
                data.event,
                data.value,
                data.value2
            ]);
        } else {
            throw 'Analytics not installed';
        }
    } catch (e) {
        console.error(e);
    }
};